module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Note on Previously Published Material")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PARTS OF CHAPTER 2 PREVIOUSLY APPEARED IN SPANISH IN")]), _vm._v(" “Re-configurando Comunidades: Judíos Sefaradíes/Árabes in Argentina, 1900–1950,” in "), _c('i', [_vm._v("Arabes y judíos en Iberoamérica: similitudes, diferencias y tensiones")]), _vm._v(" (Madrid: Dykinson, 2008). Sections of chapter 4 and chapter 5 appeared previously in “Electing ‘Miss Sefaradí’, and ‘Queen Esther’: Sephardim, Zionism, and Ethnic and National Identities in Argentina, 1933–1971,” in "), _c('i', [_vm._v("The New Jewish Argentina: Facets of Jewish Experiences in the Southern Cone")]), _vm._v(", edited by Adriana Brodsky and Raanan Rein (Leiden: Brill, 2012). Sections of chapter 6 appeared previously in “Educating Argentine Jews: Sephardim and Their Schools, 1920s–1960s,” in "), _c('i', [_vm._v("Returning to Babel: Jewish Latin American Experiences and Representations")]), _vm._v(", edited by Amalia Ran and Jean Cahan (Leiden: Brill, 2011).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5883aaa2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Fm03.vue
// module id = 78
// module chunks = 0